// services/configApi.ts

/**
 * Application configuration from backend
 */
export interface AppDomainConfig {
  mode: "soft" | "hard";
  selectionPrompt?: string;
  domainLabel?: string;
}

export interface AppConfig {
  authEnabled: boolean;
  guestAccessEnabled: boolean;
  appFeedbackEnabled: boolean;
  chatFeedbackEnabled: boolean;
  chatHistoryEnabled: boolean;
  streamingEnabled: boolean;
  domainRouting?: {
    locked?: boolean;
    defaultDomainSlug?: string;
    allowedDomainSlugs?: string[];
  } | null;
  domainConfig?: AppDomainConfig | null;
}

/**
 * Config API Service
 *
 * Handles fetching application-level configuration flags
 */

/**
 * Fetch application config from the server
 * Returns client-facing application flags
 *
 * This endpoint is public (no auth required) and cached for 5 minutes.
 * Falls back to default values if the request fails.
 */
export async function fetchAppConfig(): Promise<AppConfig> {
  try {
    const response = await fetch("/api/config");

    if (!response.ok) {
      console.warn(
        `[configApi] Failed to fetch config: ${response.status}, using defaults`
      );
      return { authEnabled: true, guestAccessEnabled: true, appFeedbackEnabled: true, chatFeedbackEnabled: true, chatHistoryEnabled: true, streamingEnabled: false };
    }

    return await response.json() as AppConfig;
  } catch (error) {
    console.error("[configApi] Error fetching config, using defaults:", error);
    return { authEnabled: true, guestAccessEnabled: true, appFeedbackEnabled: true, chatFeedbackEnabled: true, chatHistoryEnabled: true, streamingEnabled: false };
  }
}
